import paperCut from './src/Index.vue'

const duoPaperCut = {
  install: Vue => {
    Vue.component('duo-paper-cut', paperCut)
  }
}

export default duoPaperCut


//////////////////
// WEBPACK FOOTER
// ./node_modules/_duo-paper-cut@1.0.20@duo-paper-cut/index.js
// module id = 8/MV
// module chunks = 0